import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { TargetAudienceSection } from './components/TargetAudienceSection';
import { ProductSection } from './components/ProductSection';
import { CurriculumSection } from './components/CurriculumSection';
import { OpportunitySection } from './components/OpportunitySection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { CommentsSection } from './components/CommentsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { CTAButton } from './components/CTAButton';
import { SalesPopup } from './components/SalesPopup';
import { StickyBar } from './components/StickyBar';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const f = window as any;
    if (f.fbq) return;
    const n = (f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    }) as any;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '1649717146200635');
    f.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen w-full font-sans text-gray-800 selection:bg-[#D4A574] selection:text-white" data-id="element-0">
      <StickyBar data-id="element-1" />
      <HeroSection data-id="element-2" />

      <TargetAudienceSection data-id="element-3" />
      <ProductSection data-id="element-4" />

      <CurriculumSection data-id="element-5" />
      <OpportunitySection data-id="element-6" />

      <BonusesSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <CommentsSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />

      <SalesPopup data-id="element-11" />

      {/* Simple Footer */}
      <footer className="bg-[#1B4332] text-white/60 py-8 text-center text-sm" data-id="element-12">
        <p data-id="element-13">
          © {new Date().getFullYear()} Boba Professional. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}